// extracted by mini-css-extract-plugin
export default {"button":"css_button__pF+B1","black":"css_black__lsE26"};